// extracted by mini-css-extract-plugin
export var banner = "WelcomeOfferBanner-module--banner--1be95";